import { Dispatch } from 'react-redux';
import { Moment } from 'moment';

import { fetcher } from '../../lib/request';

import { CustomOrder, FlowwowOrder } from '../../models/CustomFlowers/Order';
import { FlowwowCity, CustomCity } from '../../models/CustomFlowers/City';
import { FlowwowCompilation, CustomCompilation } from '../../models/CustomFlowers/Compilation';
import { CustomBouquet, FlowwowBouquet } from '../../models/CustomFlowers/Bouquet';

const CUSTOM_FLOWERS_HOST = process.env.REACT_APP_CUSTOM_FLOWERS_HOST;
const CUSTOM_FLOWERS_KEY = process.env.REACT_APP_CUSTOM_FLOWERS_KEY;

const FFLOWERS_HOST = process.env.REACT_APP_FFLOWERS_HOST;
const FFLOWERS_KEY = process.env.REACT_APP_FFLOWERS_KEY;

export const GET_CUSTOM_FLOWERS_CITIES_REQUEST = 'CUSTOM_FLOWERS_GET_CUSTOM_FLOWERS_CITIES_REQUEST';
export const GET_CUSTOM_FLOWERS_CITIES_RESPONSE = 'CUSTOM_FLOWERS_GET_CUSTOM_FLOWERS_CITIES_RESPONSE';
export const GET_CUSTOM_FLOWERS_CITIES_ERROR = 'CUSTOM_FLOWERS_GET_CUSTOM_FLOWERS_CITIES_ERROR';

export const GET_CUSTOM_FLOWERS_BOUQUET_COMPILATION_REQUEST = 'CUSTOM_FLOWERS_GET_CUSTOM_FLOWERS_BOUQUET_COMPILATION_REQUEST';
export const GET_CUSTOM_FLOWERS_BOUQUET_COMPILATION_RESPONSE = 'CUSTOM_FLOWERS_GET_CUSTOM_FLOWERS_BOUQUET_COMPILATION_RESPONSE';
export const GET_CUSTOM_FLOWERS_BOUQUET_COMPILATION_ERROR = 'CUSTOM_FLOWERS_GET_CUSTOM_FLOWERS_BOUQUET_COMPILATION_ERROR';

export const GET_CUSTOM_FLOWERS_BOUQUET_COMPILATION_BOUQUETS_REQUEST = 'CUSTOM_FLOWERS_GET_CUSTOM_FLOWERS_BOUQUET_COMPILATION_BOUQUETS_REQUEST';
export const GET_CUSTOM_FLOWERS_BOUQUET_COMPILATION_BOUQUETS_RESPONSE = 'CUSTOM_FLOWERS_GET_CUSTOM_FLOWERS_BOUQUET_COMPILATION_BOUQUETS_RESPONSE';
export const GET_CUSTOM_FLOWERS_BOUQUET_COMPILATION_BOUQUETS_ERROR = 'CUSTOM_FLOWERS_GET_CUSTOM_FLOWERS_BOUQUET_COMPILATION_BOUQUETS_ERROR';

export const GET_CUSTOM_FLOWERS_BOUQUET_REQUEST = 'CUSTOM_FLOWERS_GET_CUSTOM_FLOWERS_BOUQUET_REQUEST';
export const GET_CUSTOM_FLOWERS_BOUQUET_RESPONSE = 'CUSTOM_FLOWERS_GET_CUSTOM_FLOWERS_BOUQUET_RESPONSE';
export const GET_CUSTOM_FLOWERS_BOUQUET_ERROR = 'CUSTOM_FLOWERS_GET_CUSTOM_FLOWERS_BOUQUET_ERROR';

export const ORDER_CUSTOM_FLOWERS_BOUQUET_REQUEST = 'CUSTOM_FLOWERS_ORDER_CUSTOM_FLOWERS_BOUQUET_REQUEST';
export const ORDER_CUSTOM_FLOWERS_BOUQUET_RESPONSE = 'CUSTOM_FLOWERS_ORDER_CUSTOM_FLOWERS_BOUQUET_RESPONSE';
export const ORDER_CUSTOM_FLOWERS_BOUQUET_ERROR = 'CUSTOM_FLOWERS_ORDER_CUSTOM_FLOWERS_BOUQUET_ERROR';

export const RESET_ORDER_CUSTOM_FLOWERS = 'CUSTOM_FLOWERS_RESET_ORDER_CUSTOM_FLOWERS';

export const GET_FLOWWOW_FLOWERS_CITIES_REQUEST = 'CUSTOM_FLOWERS_GET_FLOWWOW_FLOWERS_CITIES_REQUEST';
export const GET_FLOWWOW_FLOWERS_CITIES_RESPONSE = 'CUSTOM_FLOWERS_GET_FLOWWOW_FLOWERS_CITIES_RESPONSE';
export const GET_FLOWWOW_FLOWERS_CITIES_ERROR = 'CUSTOM_FLOWERS_GET_FLOWWOW_FLOWERS_CITIES_ERROR';

export const GET_FLOWWOW_FLOWERS_COMPILATION_REQUEST = 'CUSTOM_FLOWERS_GET_FLOWWOW_FLOWERS_COMPILATION_REQUEST';
export const GET_FLOWWOW_FLOWERS_COMPILATION_RESPONSE = 'CUSTOM_FLOWERS_GET_FLOWWOW_FLOWERS_COMPILATION_RESPONSE';
export const GET_FLOWWOW_FLOWERS_COMPILATION_ERROR = 'CUSTOM_FLOWERS_GET_FLOWWOW_FLOWERS_COMPILATION_ERROR';

export const GET_FLOWWOW_FLOWERS_COMPILATION_BOUQUETS_REQUEST = 'CUSTOM_FLOWERS_GET_FLOWWOW_FLOWERS_COMPILATION_BOUQUETS_REQUEST';
export const GET_FLOWWOW_FLOWERS_COMPILATION_BOUQUETS_RESPONSE = 'CUSTOM_FLOWERS_GET_FLOWWOW_FLOWERS_COMPILATION_BOUQUETS_RESPONSE';
export const GET_FLOWWOW_FLOWERS_COMPILATION_BOUQUETS_ERROR = 'CUSTOM_FLOWERS_GET_FLOWWOW_FLOWERS_COMPILATION_BOUQUETS_ERROR';

export const GET_MORE_FLOWWOW_FLOWERS_COMPILATION_BOUQUETS_REQUEST = 'CUSTOM_FLOWERS_GET_MORE_FLOWWOW_FLOWERS_COMPILATION_BOUQUETS_REQUEST';
export const GET_MORE_FLOWWOW_FLOWERS_COMPILATION_BOUQUETS_RESPONSE = 'CUSTOM_FLOWERS_GET_MORE_FLOWWOW_FLOWERS_COMPILATION_BOUQUETS_RESPONSE';
export const GET_MORE_FLOWWOW_FLOWERS_COMPILATION_BOUQUETS_ERROR = 'CUSTOM_FLOWERS_GET_MORE_FLOWWOW_FLOWERS_COMPILATION_BOUQUETS_ERROR';

export const GET_FLOWWOW_FLOWERS_BOUQUET_REQUEST = 'CUSTOM_FLOWERS_GET_FLOWWOW_FLOWERS_BOUQUET_REQUEST';
export const GET_FLOWWOW_FLOWERS_BOUQUET_RESPONSE = 'CUSTOM_FLOWERS_GET_FLOWWOW_FLOWERS_BOUQUET_RESPONSE';
export const GET_FLOWWOW_FLOWERS_BOUQUET_ERROR = 'CUSTOM_FLOWERS_GET_FLOWWOW_FLOWERS_BOUQUET_ERROR';

export const ORDER_FLOWWOW_FLOWERS_BOUQUET_REQUEST = 'CUSTOM_FLOWERS_ORDER_FLOWWOW_FLOWERS_BOUQUET_REQUEST';
export const ORDER_FLOWWOW_FLOWERS_BOUQUET_RESPONSE = 'CUSTOM_FLOWERS_ORDER_FLOWWOW_FLOWERS_BOUQUET_RESPONSE';
export const ORDER_FLOWWOW_FLOWERS_BOUQUET_ERROR = 'CUSTOM_FLOWERS_ORDER_FLOWWOW_FLOWERS_BOUQUET_ERROR';

export const SET_CUSTOM_FLOWERS_CITY = 'CUSTOM_FLOWERS_SET_CUSTOM_FLOWERS_CITY';
export const SET_FLOWWOW_CITY = 'CUSTOM_FLOWERS_SET_FLOWWOW_CITY';

export const SET_CUSTOM_FLOWERS_COMPILATION = 'CUSTOM_FLOWERS_SET_CUSTOM_FLOWERS_COMPILATION';
export const SET_FLOWWOW_COMPILATION = 'CUSTOM_FLOWERS_SET_FLOWWOW_COMPILATION';

export const SET_CITY_INPUT = 'CUSTOM_FLOWERS_SET_CITY_INPUT';

export const SET_CUSTOM_FLOWERS_BOUQUET = 'CUSTOM_FLOWERS_SET_CUSTOM_FLOWERS_BOUQUET';
export const SET_FLOWWOW_BOUQUET = 'CUSTOM_FLOWERS_SET_FLOWWOW_BOUQUET';

export const SET_CUSTOM_COMMENT = 'CUSTOM_FLOWERS_SET_CUSTOM_COMMENT';
export const SET_CUSTOM_DATE_TIME = 'CUSTOM_FLOWERS_SET_CUSTOM_DATE_TIME';
export const SET_CUSTOM_SENDER_NAME = 'CUSTOM_FLOWERS_SET_CUSTOM_SENDER_NAME';
export const SET_CUSTOM_SENDER_PHONE = 'CUSTOM_FLOWERS_SET_CUSTOM_SENDER_PHONE';
export const SET_CUSTOM_SENDER_CARD = 'CUSTOM_FLOWERS_SET_CUSTOM_SENDER_CARD';
export const SET_CUSTOM_RECIPIENT_NAME = 'CUSTOM_FLOWERS_SET_CUSTOM_RECIPIENT_NAME';
export const SET_CUSTOM_RECIPIENT_PHONE = 'CUSTOM_FLOWERS_SET_CUSTOM_RECIPIENT_PHONE';
export const SET_CUSTOM_RECIPIENT_ADDRESS = 'CUSTOM_FLOWERS_SET_CUSTOM_RECIPIENT_ADDRESS';

export const SET_FLOWWOW_DELIVERY_FROM = 'CUSTOM_FLOWERS_SET_FLOWWOW_DELIVERY_FROM';
export const SET_FLOWWOW_DELIVERY_TO = 'CUSTOM_FLOWERS_SET_FLOWWOW_DELIVERY_TO';
export const SET_FLOWWOW_DELIVERY_TYPE = 'CUSTOM_FLOWERS_SET_FLOWWOW_DELIVERY_TYPE';
export const SET_FLOWWOW_SENDER_NAME = 'CUSTOM_FLOWERS_SET_FLOWWOW_SENDER_NAME';
export const SET_FLOWWOW_SENDER_PHONE = 'CUSTOM_FLOWERS_SET_FLOWWOW_SENDER_PHONE';
export const SET_FLOWWOW_SENDER_CARD = 'CUSTOM_FLOWERS_SET_FLOWWOW_SENDER_CARD';
export const SET_FLOWWOW_RECIPIENT_NAME = 'CUSTOM_FLOWERS_SET_FLOWWOW_RECIPIENT_NAME';
export const SET_FLOWWOW_RECIPIENT_PHONE = 'CUSTOM_FLOWERS_SET_FLOWWOW_RECIPIENT_PHONE';
export const SET_FLOWWOW_RECIPIENT_ADDRESS = 'CUSTOM_FLOWERS_SET_FLOWWOW_RECIPIENT_ADDRESS';
export const getCustomFlowersCitiesAction = (query: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_CUSTOM_FLOWERS_CITIES_REQUEST
    });

    try {
        const response = await fetcher(`${CUSTOM_FLOWERS_HOST}/api/v1/cities${!!query ? `?q=${query}` : ''}`)
            .auth(`Basic ${CUSTOM_FLOWERS_KEY}`)
            .json();

        dispatch({
            type: GET_CUSTOM_FLOWERS_CITIES_RESPONSE,
            response: response
        });
    } catch (error) {
        dispatch({
            type: GET_CUSTOM_FLOWERS_CITIES_ERROR,
            error: error
        });
    }
};

export const getCustomFlowersBouquetCompilationsAction = (cityId: number) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_CUSTOM_FLOWERS_BOUQUET_COMPILATION_REQUEST
    });

    try {
        const response = await fetcher(`${CUSTOM_FLOWERS_HOST}/api/v1/bouquet_compilations?city_id=${cityId}`)
            .auth(`Basic ${CUSTOM_FLOWERS_KEY}`)
            .json();

        dispatch({
            type: GET_CUSTOM_FLOWERS_BOUQUET_COMPILATION_RESPONSE,
            response: response
        });
    } catch (error) {
        dispatch({
            type: GET_CUSTOM_FLOWERS_BOUQUET_COMPILATION_ERROR,
            error: error
        });
    }
};

export const getCustomFlowersBouquetCompilationsBouquetsAction = (compilationId: number, cityId: number) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_CUSTOM_FLOWERS_BOUQUET_COMPILATION_BOUQUETS_REQUEST
    });

    try {
        const response = await fetcher(`${CUSTOM_FLOWERS_HOST}/api/v1/bouquet_compilations/${compilationId}?city_id=${cityId}`)
            .auth(`Basic ${CUSTOM_FLOWERS_KEY}`)
            .json();

        dispatch({
            type: GET_CUSTOM_FLOWERS_BOUQUET_COMPILATION_BOUQUETS_RESPONSE,
            response: response
        });
    } catch (error) {
        dispatch({
            type: GET_CUSTOM_FLOWERS_BOUQUET_COMPILATION_BOUQUETS_ERROR,
            error: error
        });
    }
};

export const getCustomFlowersBouquetAction = (bouquetId: number, cityId: number, userId: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_CUSTOM_FLOWERS_BOUQUET_REQUEST
    });

    try {
        const response = await fetcher(`${CUSTOM_FLOWERS_HOST}/api/v1/bouquets/${bouquetId}?city_id=${cityId}&user_id=${userId}`)
            .auth(`Basic ${CUSTOM_FLOWERS_KEY}`)
            .json();

        dispatch({
            type: GET_CUSTOM_FLOWERS_BOUQUET_RESPONSE,
            response: response
        });
    } catch (error) {
        dispatch({
            type: GET_CUSTOM_FLOWERS_BOUQUET_ERROR,
            error: error
        });
    }
};

export const orderCustomFlowersBouquetAction = (bouquetId: number, order: CustomOrder) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: ORDER_CUSTOM_FLOWERS_BOUQUET_REQUEST
    });

    try {
        const response = await fetcher(`${CUSTOM_FLOWERS_HOST}/api/v1/bouquets/${bouquetId}/order`)
            .post(order)
            .contentType('application/json')
            .auth(`Basic ${CUSTOM_FLOWERS_KEY}`)
            .json();

        dispatch({
            type: ORDER_CUSTOM_FLOWERS_BOUQUET_RESPONSE,
            response: response
        });
    } catch (error) {
        dispatch({
            type: ORDER_CUSTOM_FLOWERS_BOUQUET_ERROR,
            error: error
        });
    }
};

export const getFlowwowFlowersCitiesAction = (query: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_FLOWWOW_FLOWERS_CITIES_REQUEST
    });

    try {
        const response = await fetcher(`${FFLOWERS_HOST}/api/v1/cities${!!query ? `?q=${query}` : ''}`)
            .auth(`Basic ${FFLOWERS_KEY}`)
            .json();

        dispatch({
            type: GET_FLOWWOW_FLOWERS_CITIES_RESPONSE,
            response: response
        });
    } catch (error) {
        dispatch({
            type: GET_FLOWWOW_FLOWERS_CITIES_ERROR,
            error: error
        });
    }
};

export const getFlowwowFlowersBouquetCompilationsBouquetsAction = (cityId: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_FLOWWOW_FLOWERS_COMPILATION_REQUEST
    });

    try {
        const response = await fetcher(`${FFLOWERS_HOST}/api/v1/compilations?city_id=${cityId}`)
            .auth(`Basic ${FFLOWERS_KEY}`)
            .json();

        dispatch({
            type: GET_FLOWWOW_FLOWERS_COMPILATION_RESPONSE,
            response: response
        });
    } catch (error) {
        dispatch({
            type: GET_FLOWWOW_FLOWERS_COMPILATION_ERROR,
            error: error
        });
    }
};

export const getFlowwowFlowersCompilationsBouquetsAction = (compilationId: number, cityId: string, page: number = 0) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_FLOWWOW_FLOWERS_COMPILATION_BOUQUETS_REQUEST
    });

    try {
        const response = await fetcher(`${FFLOWERS_HOST}/api/v1/bouquets?compilation_id=${compilationId}&city_id=${cityId}&page=${page}`)
            .auth(`Basic ${FFLOWERS_KEY}`)
            .json();

        dispatch({
            type: GET_FLOWWOW_FLOWERS_COMPILATION_BOUQUETS_RESPONSE,
            response: response
        });
    } catch (error) {
        dispatch({
            type: GET_FLOWWOW_FLOWERS_COMPILATION_BOUQUETS_ERROR,
            error: error
        });
    }
};

export const getFlowwowFlowersBouquetAction = (
    bouquetId: number,
    bouquetName: string,
    bouquetPrice: number,
    deliveryPrice: number,
    cityId: string,
    cityName: string,
    cityRegion: string,
    userId: string
) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_FLOWWOW_FLOWERS_BOUQUET_REQUEST
    });

    try {
        const response = await fetcher(`${FFLOWERS_HOST}/api/v1/bouquets/${bouquetId}?bouquet_name=${bouquetName}` +
            `&bouquet_price=${bouquetPrice}&delivery_price=${deliveryPrice}&city_id=${cityId}&city_name=${cityName}` +
            `&city_region=${cityRegion}&user_id=${userId}`)
            .auth(`Basic ${FFLOWERS_KEY}`)
            .json();

        dispatch({
            type: GET_FLOWWOW_FLOWERS_BOUQUET_RESPONSE,
            response: response
        });
    } catch (error) {
        dispatch({
            type: GET_FLOWWOW_FLOWERS_BOUQUET_ERROR,
            error: error
        });
    }
};

export const orderFlowwowFlowersBouquetAction = (bouquetId: number, order: FlowwowOrder) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: ORDER_FLOWWOW_FLOWERS_BOUQUET_REQUEST
    });

    try {
        const response = await fetcher(`${FFLOWERS_HOST}/api/v1/bouquets/${bouquetId}/order`)
            .post(order)
            .contentType('application/json')
            .auth(`Basic ${FFLOWERS_KEY}`)
            .json();

        dispatch({
            type: ORDER_FLOWWOW_FLOWERS_BOUQUET_RESPONSE,
            response: response
        });
    } catch (error) {
        dispatch({
            type: ORDER_FLOWWOW_FLOWERS_BOUQUET_ERROR,
            error: error
        });
    }
};

export const getMoreFlowwowBouquetsAction = (compilationId: number, cityId: string, page: number) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_MORE_FLOWWOW_FLOWERS_COMPILATION_BOUQUETS_REQUEST
    });

    try {
        const response = await fetcher(`${FFLOWERS_HOST}/api/v1/bouquets?compilation_id=${compilationId}` +
            `&city_id=${cityId}&page=${page}`)
            .auth(`Basic ${FFLOWERS_KEY}`)
            .json();

        dispatch({
            type: GET_MORE_FLOWWOW_FLOWERS_COMPILATION_BOUQUETS_RESPONSE,
            response,
            page: page + 1
        });
    } catch (error) {
        dispatch({
            type: GET_MORE_FLOWWOW_FLOWERS_COMPILATION_BOUQUETS_ERROR,
            error
        });
    }
};

export const setCustomBouquetAction = (bouquet: CustomBouquet) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_CUSTOM_FLOWERS_BOUQUET,
        bouquet
    });
};

export const setFlowwowBouquetAction = (bouquet: FlowwowBouquet) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_FLOWWOW_BOUQUET,
        bouquet
    });
};

export const resetOrderCustomFlowersAction = () => (dispatch: Dispatch<any>) => dispatch({
    type: RESET_ORDER_CUSTOM_FLOWERS
});

export const setFlowwowCityAction = (city: FlowwowCity) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_FLOWWOW_CITY,
        city
    });
};

export const setCustomCityAction = (city: CustomCity) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_CUSTOM_FLOWERS_CITY,
        city
    });
};

export const setFlowwowCompilationAction = (compilation: FlowwowCompilation) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_FLOWWOW_COMPILATION,
        compilation
    });
};

export const setCustomCompilationAction = (compilation: CustomCompilation) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_CUSTOM_FLOWERS_COMPILATION,
        compilation
    });
};

export const setCityInputAction = (city: string) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_CITY_INPUT,
        city
    });
};

export const setCustomCommentsAction = (comment: string) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_CUSTOM_COMMENT,
        comment
    });
};

export const setCustomDateTimeAction = (dateTime: Moment) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_CUSTOM_DATE_TIME,
        dateTime
    });
};

export const setCustomSenderNameAction = (name: string) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_CUSTOM_SENDER_NAME,
        name
    });
};

export const setCustomSenderPhoneAction = (phone: string) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_CUSTOM_SENDER_PHONE,
        phone
    });
};

export const setCustomSenderCardAction = (card: string) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_CUSTOM_SENDER_CARD,
        card
    });
};

export const setCustomRecipientNameAction = (name: string) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_CUSTOM_RECIPIENT_NAME,
        name
    });
};

export const setCustomRecipientPhoneAction = (phone: string) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_CUSTOM_RECIPIENT_PHONE,
        phone
    });
};

export const setCustomRecipientAddressAction = (address: string) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_CUSTOM_RECIPIENT_ADDRESS,
        address
    });
};

export const setFlowwowDeliveryFromAction = (deliveryFrom: Moment) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_FLOWWOW_DELIVERY_FROM,
        deliveryFrom
    });
};

export const setFlowwowDeliveryToAction = (deliveryTo: Moment) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_FLOWWOW_DELIVERY_TO,
        deliveryTo
    });
};

export const setFlowwowDeliveryTypeAction = (deliveryType: 1 | 2) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_FLOWWOW_DELIVERY_TYPE,
        deliveryType
    });
};

export const setFlowwowSenderNameAction = (name: string) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_FLOWWOW_SENDER_NAME,
        name
    });
};

export const setFlowwowSenderPhoneAction = (phone: string) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_FLOWWOW_SENDER_PHONE,
        phone
    });
};

export const setFlowwowSenderCardAction = (card: string) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_FLOWWOW_SENDER_CARD,
        card
    });
};

export const setFlowwowRecipientNameAction = (name: string) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_FLOWWOW_RECIPIENT_NAME,
        name
    });
};

export const setFlowwowRecipientPhoneAction = (phone: string) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_FLOWWOW_RECIPIENT_PHONE,
        phone
    });
};

export const setFlowwowRecipientAddressAction = (address: string) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_FLOWWOW_RECIPIENT_ADDRESS,
        address
    });
};



// WEBPACK FOOTER //
// ./src/actions/CustomFlowers/customFlowers.ts